import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LuciPersonalizationTableColumnsComponent} from './luci-personalization-table-columns.component';
import {LuciDialogModule} from '../luci-dialog/luci-dialog.module';
import {LuciCheckboxModule} from '../luci-checkbox/luci-checkbox.module';
import {LuciButtonModule} from '../luci-button/luci-button.module';



@NgModule({
  declarations: [LuciPersonalizationTableColumnsComponent],
  imports: [
    CommonModule,
    LuciDialogModule,
    LuciCheckboxModule,
    LuciButtonModule
  ],
  exports: [LuciPersonalizationTableColumnsComponent]
})
export class LuciPersonalizationTableColumnsModule { }
